
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"font-family":"sans-serif"}},[_c('path',{attrs:{"d":"M.871 0a.871.871 0 00-.87.872v16.265a.871.871 0 00.87.871h9.294a.871.871 0 00.871-.871.871.871 0 00-.871-.871H1.743V1.743h8.422a.871.871 0 00.871-.871.871.871 0 00-.871-.872z","overflow":"visible"}}),_c('path',{attrs:{"d":"M13.657 4.648a.871.871 0 00-.624.254.871.871 0 000 1.234l1.997 1.997H5.518a.871.871 0 00-.871.871.871.871 0 00.871.872h9.512l-1.998 1.997a.871.871 0 000 1.234.871.871 0 001.235 0l3.485-3.486a.871.871 0 000-1.234l-3.485-3.485a.871.871 0 00-.61-.254z","overflow":"visible"}})])])
          )
        }
      }
    